import {A} from "@solidjs/router"
import btn from "~/css/components/ui/button.module.css"
import css from "~/css/layout/footer.module.css"
import Container from "~/components/Container";

export default function Footer() {
    return (
        <footer class={css.footer}>
            <Container>
                <div class={css.ctaBanner}>
                    <h3>Get a <strong>FREE</strong> Tag When You Order Today!</h3>
                    <p>Keep your pet safe with a free, personalized tag from Tag-Tails. One
                        scan and you’re
                        connected.</p>
                    <A href="/product/tag" class={btn.secondarySolid}>Claim Now</A>
                </div>
            </Container>
            <div class={css.legalBanner}>
                <nav>
                    <A href="/terms">Terms & Conditions</A>
                    <A href="/privacy">Privacy Policy</A>
                    <A href="/cookies">Cookies Policy</A>
                </nav>
                <span>&copy; Tag-Tails 2025</span>
            </div>
        </footer>
    )
}